import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchCurrentUserFollowing,
  selectCurrentUser,
} from 'features/auth/slice';

import { recordsMatch } from '@frontendmentorio/design-system-v2';

import Comments from './Comments';
import Hero from './Hero';
import Solutions from './Solutions';

export default function Overview({ user }) {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);
  const isCurrentUser = recordsMatch(currentUser, user);

  useEffect(() => {
    if (!currentUser || isCurrentUser) return;

    dispatch(fetchCurrentUserFollowing());
  }, [currentUser, isCurrentUser]);

  return (
    <>
      <Hero isCurrentUser={isCurrentUser} user={user} />
      <Solutions
        isCurrentUser={isCurrentUser}
        currentUser={currentUser}
        user={user}
      />
      <Comments isCurrentUser={isCurrentUser} user={user} />
    </>
  );
}
